export default "__VITE_ASSET__Dyjv5DmS__"